import { render, staticRenderFns } from "./Followuprecords.vue?vue&type=template&id=22e0002e&"
import script from "./Followuprecords.vue?vue&type=script&lang=js&"
export * from "./Followuprecords.vue?vue&type=script&lang=js&"
import style0 from "./Followuprecords.vue?vue&type=style&index=0&id=22e0002e&lang=css&"
import style1 from "./Followuprecords.vue?vue&type=style&index=1&id=22e0002e&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e0002e')) {
      api.createRecord('22e0002e', component.options)
    } else {
      api.reload('22e0002e', component.options)
    }
    module.hot.accept("./Followuprecords.vue?vue&type=template&id=22e0002e&", function () {
      api.rerender('22e0002e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/Followup/Followuprecords.vue"
export default component.exports